module.exports = __webpack_public_path__ + "img/04_fh.61e39354.jpg";